import React from 'react';
import { createSvgIcon } from '@mui/material';

const CustomText = createSvgIcon(
  <path
    clipRule="evenodd"
    fillRule="evenodd"
    d="M7.073 5.677h6.454c.373 0 .732.147.993.414l3.4 3.394c.267.26.414.618.414.99v6.443a1.41 1.41 0 0 1-1.407 1.405H7.073a1.41 1.41 0 0 1-1.407-1.405V7.082a1.41 1.41 0 0 1 1.407-1.405m7.742 8.43h-5.63a.705.705 0 0 0-.704.703c0 .387.317.703.704.703h5.63a.705.705 0 0 0 .704-.703.705.705 0 0 0-.704-.702Zm0-2.81h-5.63A.705.705 0 0 0 8.48 12c0 .386.317.703.704.703h5.63A.705.705 0 0 0 15.52 12a.705.705 0 0 0-.704-.703ZM9.12 8.234a.708.708 0 0 0 0 1.416h3.755a.708.708 0 0 0 0-1.416z"
  />,
  'CustomText',
);

export default CustomText;
